<template>
  <div>
    <div class="row">
      <legend class="col-12 col-form-label text-primary pt-0 mb-3">
        <h5>2. SOLICITUD</h5>
      </legend>
    </div>

    <!-- <div
      class="row"
      v-if="
        [
          'OINSP',
          'CSGAS',
          'OCSG',
          'CSIA',
          'CSA',
          'OCPR',
          'OCLN',
          'OICC',
        ].includes(this.activity)
      "
    >
      <legend class="col-12 col-form-label text-primary pt-0 mb-3">
        <h5>
          {{
            ["OINSP"].includes(this.activity)
              ? "2.1 EN CONCORDANCIA CON LA NORMA NTE INEN ISO/IEC 17020:2013, EL ORGANISMO DE INSPECCION SOLICITA LA EVALUACIÓN PARA:"
              : ["CSGAS", "OCSG", "CSIA", "CSA"].includes(this.activity)
              ? "2.2 EN CONCORDANCIA CON LA NORMA ISO/IEC 17021-1, EL ORGANISMO DE CERTIFICACIÓN SOLICITA LA EVALUACIÓN PARA:"
              : ["OCPR"].includes(this.activity)
              ? "2.1 EN CONCORDANCIA CON LA NTE INEN ISO/IEC 17065:2013, EL ORGANISMO DE CERTIFICACIÓN SOLICITA LA EVALUACIÓN PARA:"
              : ["OCLN"].includes(this.activity)
              ? "2.1 EN CONCORDANCIA CON LA NORMA ISO 15189:2012, EL LABORATORIO CLINICO / SOLICITA LA EVALUACIÓN PARA:"
              : ["OICC"].includes(this.activity)
              ? "2.1 De acuerdo con la norma NTE INEN ISO/IEC 17025:2018, el laboratorio de ensayo solicita lo indicado en esta solicitud como:"
              : ""
          }}
        </h5>
      </legend>

      <div class="col-12">
        <div class="form-group">
          <label>
            {{
              ["OINSP"].includes(this.activity)
                ? "*En caso de tratarse de la actualización del alcance de la acreditación por cambio en documentos normativos, describir el (los) documento (s) normativo (s) para los que solicita la evaluación y solo aplicará para los casos en los cuales los cambios sean netamente técnicos."
                : ["CSGAS", "OCSG", "CSIA", "CSA"].includes(this.activity)
                ? "*En caso de tratarse de la actualización del alcance de la acreditación por cambio en documentos normativos (CDN), describir el (los) documento (s) normativo (s) para los que solicita la evaluación."
                : ["OCPR"].includes(this.activity)
                ? "*En caso de tratarse de la actualización del alcance de la acreditación por cambio en documentos normativos, describir el (los) documento (s) normativo (s) para los que solicita la evaluación"
                : ["OCLN"].includes(this.activity)
                ? "*En caso de tratarse de la actualización del alcance de la acreditación por cambio en documentos normativos, describir el (los) documento (s) normativo (s) para los que solicita la evaluación"
                : ["OICC"].includes(this.activity)
                ? "*En caso de tratarse de la actualización del alcance de la acreditación por cambio en documentos normativos, describir el (los) documento (s) normativo (s) para los que solicita la evaluación y solo aplicará para los casos en los cuales los cambios sean netamente técnicos."
                : ""
            }}
          </label>
          <app-input
            type="textarea"
            v-model="inputs.normative_documents"
            :disabled="disabled"
          />
          <span class="text-warning">NA sino aplica</span>
        </div>
      </div>
    </div> -->

    <div class="row" v-if="['OEAP'].includes(this.activity)">
      <legend class="col-12 col-form-label text-primary pt-0 mb-3">
        <h5>
          2.2 Fecha a partir de la cual desearía se realice la evaluación:
        </h5>
      </legend>

      <div class="col-12 col-md-6">
        <div class="form-group">
          <app-input
            type="date"
            v-model="inputs.evaluation_date"
            :disabled="disabled"
          />
        </div>
      </div>
    </div>

    <div
      class="col-12"
      v-if="['112'].includes(this.status) && inputs.description_scope"
    >
      <div class="form-group">
        <label class="text-danger"
          >ALCANCE NO APROPIADO - DESCRIPCIÓN DE LAS RAZONES</label
        >
        <app-input
          type="textarea"
          v-model="inputs.description_scope"
          :disabled="true"
        />
      </div>
    </div>

    <scopes-table
      :activity="activity"
      v-if="activity && status"
      :title="
        ['OCPR', 'OCPE', 'OINSP'].includes(this.activity)
          ? '2.2 ALCANCE DE LA ACREDITACIÓN SOLICITADA'
          : ['CSGAS', 'OCSG', 'CSA', 'CSIA', 'OEAP'].includes(this.activity)
          ? '2.3 ALCANCE DE ACREDITACIÓN'
          : ['OENY', 'OEYC'].includes(this.activity)
          ? '3 ALCANCE DE LA ACREDITACIÓN'
          : ['OCLN', 'OICC'].includes(this.activity)
          ? '2.2 ALCANCE DE LA ACREDITACIÓN'
          : ''
      "
      :disabled="disabled"
      :status="status"
    />

    <div v-if="['OENY', 'OICC'].includes(this.activity)">
      <scope-sampling-table
        title="¿Incluye muestreo?"
        tableId="scope-sampling-table"
        modalTitle="Añadir Muestra"
        editModalTitle="Editar Muestra"
        :activity="activity"
        :disabled="disabled"
      />
    </div>

    <form
      ref="form"
      :data-url="`/request/accApp/`"
      class="mb-0 mt-3"
      :class="{ 'loading-opacity': preloader }"
    >
      <div
        class="row"
        v-if="['OEYC', 'OENY', 'OCLN', 'OICC', 'OINSP'].includes(activity)"
      >
        <div
          class="col-12"
          v-if="['OEYC', 'OENY', 'OCLN', 'OICC', 'OINSP'].includes(activity)"
        >
          <legend class="col-form-label text-primary pt-0 my-3">
            <h5>
              {{
                ["OEYC", "OENY"].includes(activity)
                  ? "3.3 ¿LOS INFORMES DE ENSAYO / CALIBRACIÓN INCLUYEN OPINIONES Y/O INTERPRETACIONES*?"
                  : ["OCLN"].includes(activity)
                  ? "2.3 ¿LOS INFORMES DE ANÁLISIS INCLUYEN OPINIONES Y/O INTERPRETACIONES*?"
                  : ["OICC"].includes(activity)
                  ? "2.3 ¿LOS INFORMES DE ENSAYO INCLUYEN OPINIONES Y/O INTERPRETACIONES?"
                  : ["OINSP"].includes(activity)
                  ? "2.3 El servicio de inspección para el cual solicita la acreditación, requiere realizar mediciones?"
                  : ""
              }}
            </h5>
          </legend>

          <div class="form-group">
            <app-input
              type="radio-buttons"
              :list="confirm"
              v-model="inputs.scope_check_1"
              :disabled="disabled"
            />
          </div>
        </div>

        <div class="col-12" v-if="['OENY', 'OCLN', 'OINSP'].includes(activity)">
          <legend class="col-form-label text-primary pt-0 my-3">
            <h5>
              {{
                ["OENY"].includes(activity)
                  ? "3.4 ¿PARA LABORATORIO DE ENSAYOS: ESTE REALIZA ACTIVIDADES DE CALIBRACIÓN INTERNAS DE EQUIPOS UTILIZADOS PARA LAS ACTIVIDADES DE MEDICIÓN INCLUIDAS EN EL ALCANCE DE ACREDITACIÓN?"
                  : ["OCLN"].includes(activity)
                  ? "2.4 ¿EL LABORATORIO REALIZA ACTIVIDADES DE CALIBRACIÓN INTERNAS DE EQUIPOS UTILIZADOS PARA LAS ACTIVIDADES DE MEDICIÓN INCLUIDAS EN EL ALCANCE DE ACREDITACIÓN?"
                  : ["OINSP"].includes(activity)
                  ? "2.4 Realiza actividades de calibración internas de equipos utilizados para las actividades de medición incluidas en el alcance de acreditación?"
                  : ""
              }}
            </h5>
          </legend>

          <div class="form-group">
            <app-input
              type="radio-buttons"
              :list="confirm"
              v-model="inputs.scope_check_2"
              :disabled="disabled"
            />
          </div>
        </div>

        <div class="col-12 mt-3" v-if="!disabled">
          <button type="submit" class="btn btn-primary" @click.prevent="submit">
            {{ $t("save") }}
          </button>
        </div>
      </div>

      <div class="row" v-if="['OCPR'].includes(activity)">
        <legend class="col-12 col-form-label text-primary pt-0 my-3">
          <h5>
            2.3 ¿PARA ALGÚN ALCANCE SOLICITADO EN EL PUNTO 2.2, ES NECESARIA LA
            AUTORIZACIÓN, CALIFICACIÓN O REGISTRO PREVIO ANTE EL PROPIETARIO DEL
            ESQUEMA (POR EJEMPLO: GLOBALGAP, FLORECUADOR®, ETC.)?
          </h5>
        </legend>

        <div class="col-12">
          <div class="form-group">
            <app-input
              type="radio-buttons"
              :list="confirm"
              v-model="inputs.scope_check_1"
              :disabled="disabled"
            />
          </div>
        </div>

        <div class="col-md-12" v-if="inputs.scope_check_1">
          <div class="form-group">
            <label>Especifique el alcance</label>
            <app-input
              type="textarea"
              v-model="inputs.scope_text_1"
              :required="true"
              :disabled="disabled"
            />
          </div>
        </div>

        <div class="col-12" v-if="inputs.scope_check_1">
          <div class="form-group">
            <label
              >Si la respuesta es positiva, el organismo dispone de dicha
              autorización, calificación o registro?</label
            >
            <app-input
              type="radio-buttons"
              :list="confirm"
              v-model="inputs.scope_check_2"
              :disabled="disabled"
            />
          </div>
        </div>

        <div
          class="col-md-12"
          v-if="inputs.scope_check_1 && inputs.scope_check_2"
        >
          <div class="form-group">
            <label>Especifique el nombre del documento</label>
            <app-input
              type="textarea"
              v-model="inputs.scope_text_2"
              :required="true"
              :disabled="disabled"
            />
          </div>
        </div>

        <div class="col-12 mt-3" v-if="!disabled">
          <button type="submit" class="btn btn-primary" @click.prevent="submit">
            {{ $t("save") }}
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { axiosPost } from "@/app/helpers/AxiosHelper";
export default {
  mixins: [FormMixin],
  data() {
    return {
      preloader: false,
      inputs: {},
      confirm: [
        {
          id: 0,
          value: "NO",
        },
        {
          id: 1,
          value: "SI",
        },
      ],
      delayTimer: null,
    };
  },
  computed: {
    activity() {
      return this.$store.state.accreditation.app != null
        ? this.$store.state.accreditation.app.accreditation_activity.code
        : null;
    },
    status() {
      return this.$store.state.accreditation.app != null
        ? this.$store.state.accreditation.app.status.code
        : null;
    },
    disabled() {
      return !["100", "112"].includes(this.status);
    },
  },
  watch: {
    "inputs.normative_documents": function () {
      clearTimeout(this.delayTimer);
      this.delayTimer = setTimeout(this.update, 1000);
    },
    "inputs.evaluation_date": function () {
      clearTimeout(this.delayTimer);
      this.delayTimer = setTimeout(this.update, 1000);
    },
  },
  created() {
    this.data();
  },
  methods: {
    beforeSubmit() {
      this.preloader = true;
    },
    submit() {
      this.save(this.inputs);
    },

    afterSuccess(res) {
      // this.$toastr.s(res.data.message);
      const { data } = res.data;
      this.inputs = {
        id: data.id,
        scope_check_1: data.scope_check_1,
        scope_check_2: data.scope_check_2,
        scope_text_1: data.scope_text_1,
        scope_text_2: data.scope_text_2,
        normative_documents: data.normative_documents,
        evaluation_date: data.evaluation_date
          ? new Date(data.evaluation_date)
          : null,
        description_scope: data.description_scope
          ? data.description_scope.toUpperCase()
          : "",
      };
      this.$toastr.s(this.$t("updated_success"));
    },

    afterFinalResponse() {
      this.preloader = false;
    },

    afterError(res) {
      this.$toastr.e(res.data.message);
    },

    data() {
      this.preloader = true;
      this.axiosGet(
        `/accreditations/applications/form/${this.$store.state.accreditation.id}`
      )
        .then((response) => {
          if (response.status == 200 && response.data) {
            this.inputs = {
              id: response.data.id,
              scope_check_1: response.data.scope_check_1,
              scope_check_2: response.data.scope_check_2,
              scope_text_1: response.data.scope_text_1,
              scope_text_2: response.data.scope_text_2,
              normative_documents: response.data.normative_documents,
              evaluation_date: response.data.evaluation_date
                ? new Date(response.data.evaluation_date)
                : null,
              description_scope: response.data.description_scope
                ? response.data.description_scope.toUpperCase()
                : "",
            };
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },

    update() {
      const tmp = {
        id: this.inputs.id,
        normative_documents: this.inputs.normative_documents,
        evaluation_date: this.inputs.evaluation_date,
      };

      if (tmp.evaluation_date) {
        const d = tmp.evaluation_date;
        tmp.evaluation_date = [
          d.getFullYear(),
          d.getMonth() + 1,
          d.getDate(),
        ].join("-");
      }

      axiosPost("/request/accApp/", tmp)
        .then((res) => {})
        .catch(({ error }) => {});
    },
  },
};
</script>
